import { RouterContext } from '../../../types/router';
import { Dispatch, GetState } from '../../redux.types';
import { buildLoadDataCachedFn, fetchDataOnProjectChange } from './utils/utils';
import { loadSdk } from '../../files/files.actions';
import { statuses } from '../../../constants/project';
import { getDefaultProject } from '../../projects/projects.selectors';
import { getProjectsData } from './projects';
import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';

/**
 * Only loads  common data for Jobs Page. Doesn't load jobs themselves.
 * This is needed in order to show 2 different spinners: one for whole screen and
 * another for jobs list
 */
export const getCommonDataForJobsFunction = (
  routerContext: RouterContext,
  dispatch: Dispatch,
  getState,
) => {
  const organizationId = getSelectedOrganizationId(getState(), {
    router: routerContext,
  });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch(getProjectsData(routerContext)).then((): any => {
    const updatedState = getState();
    const project = getDefaultProject(updatedState, {
      router: routerContext,
    });

    if (!project || project.status !== statuses.READY) {
      return null;
    }

    return loadSdk(organizationId, project);
  });
};

const loadCommonDataCached = buildLoadDataCachedFn(
  getCommonDataForJobsFunction,
  fetchDataOnProjectChange,
);

export const loadCommonDataForJobsRoute =
  (context: RouterContext) => (dispatch: Dispatch, getState: GetState) => {
    return loadCommonDataCached(context, dispatch, getState);
  };
